import { injectSpeedInsights } from '@vercel/speed-insights'
export { wrapRootElement } from './wrap-root-element'

injectSpeedInsights({ framework: 'gatsby' })
